<template>
    <div>
        <fieldset>
            <txt label="company_name" v-model="model.name"></txt>
            <div class="split-fields">
                <txt label="id_number" v-model="model.id_number"></txt>
                <txt label="website" v-model="model.website"></txt>
            </div>
            <div class="split-fields">
                <txt label="email" v-model="model.email"></txt>
                <txt label="phone" v-model="model.phone"></txt>
            </div>
        </fieldset>
        <address-form name="CompanyCreate" v-model="address"></address-form>
        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'address-form': require('../address-form.vue').default,
        },
        data() {
            return {
                model: {
                    name: '',
                    id_number: '',
                    website: '',
                    email: '',
                    phone: '',
                },
                address: {}
            }
        },
        created() {
            this.$eventHub.$on('companySubmit', this.store);
        },
        methods: {
            store(){
                let before = this.model;
                this.model = Object.assign({}, this.model, this.address);
                this.$store('/api/company/store', this);
                this.model = before;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('companySubmit', this.store);
        }
    }
</script>